import { render, staticRenderFns } from "./mycollect.vue?vue&type=template&id=72e01300&scoped=true&"
import script from "./mycollect.vue?vue&type=script&lang=js&"
export * from "./mycollect.vue?vue&type=script&lang=js&"
import style0 from "./mycollect.vue?vue&type=style&index=0&id=72e01300&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e01300",
  null
  
)

export default component.exports